import { RouteCalcStatus, VoyageRoute } from "../../../src/models/voyage-routing-model";

export const DropDown_Options = ["Fuel Consumption","Distance","Avg Speed","Wave Height","Wind"]
export const  ElementMapper : any= {
    "Fuel Consumption": "fuel",
    "Distance": "distance",
    "Wave Height": "maxwave",
    "Wind": "maxwind",
    "Avg Speed": "avgSpeed"
}
export type CalculatedValues  = {
    fuel: string;
    distance: string;
    distancePilotToPilot: string;
    avgSpeed: string;
    avgSpeedPilotToPilot: string;
    maxwind: string;
    maxwave: string;
    maxswell: string;
    name: string;
}

export type UIRouteWithCalculatedValues = {
    status: RouteCalcStatus;
    route: VoyageRoute|null;
    error: string|null;
    selected: boolean;
    crossingWhaleZones: boolean;
    routeId: string;
    calculatedValues: CalculatedValues;
}

export enum AlignStarRouteEvents {
    AlignStarRouteModalClick = "alignStarRoute-modal-clicked"
}

export enum SuggestedRouteEvents {
    RoutesChanged = "routes-changed",
    StarRoutesChanged = "star-routes-changed",
    WeatherLimitsChanged = "weather-limits-changed",
    PlanChanged = "plan-changed",
    BestPracticeRouteChanged = "bestPracticeRoute-changed",
    RetryBprJob = "retry-bpr-job",
    RankedBPRUpdated = "ranked-BPR-updated",
    RankedBPRStarted = "ranked-BPR-started",
    RecalcParametersChanged = "recalc-parameters-changed",
    OorCalculationFailed = "oor-calculation-failed",
};

export enum SuggestedRouteStatusEvents {
    StatusChanged = "bpr-job-status-changed",
    StageEstimateChanged = "bpr-job-stage-estimate-changed",
    JobProgressChanged = "bpr-job-progress-changed",
};

export const HIDE_DELETE_ICON = "Star Route 1";

export const StarRoute1 = "Star Route 1";

export enum PassagePlanEvents {
    UpdatingPlan = "updating-plan",
    UpdatingPlanCompleted = "updating-plan-completed",
};
